/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Databricks integration configuration
*/
export class DatabricksIntegrationConfig {
  'serverHostname'?: string;
  'oauth2ClientId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "serverHostname",
      "baseName": "serverHostname",
      "type": "string",
      "format": ""
    },
    {
      "name": "oauth2ClientId",
      "baseName": "oauth2ClientId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DatabricksIntegrationConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

